function pr_produkty() {
  //var $produkty;
  $(".products").each(function() {
    if ($(this).hasClass("products-inline")) return;

    $(this)
      .find(".product")
      .each(function(index) {
        //$produkty = $(this).parent();

        var produkt = $(this);
        if (!index && $(this).find(".cnt").length) return false;

        let url = $(this)
          .find("a.name")
          .attr("href");
        let kod = `
                <div class="avbl"></div>
                <div class="cnt">
                  <div class="leva">
                    <div class="old"></div>
                    <div class="cena"></div>
                  </div>
                  <div class="prava">
                    <a href="${url}" class="btn btn-primary" aria-hidden="true" tabindex="-1">Detail</a>
                  </div>
                </div>`;

        $(kod).insertAfter($(this).find("a.name"));

        produkt.find(".availability").each(function() {
          let text = $(this)
            .find("span:first")
            .text()
            .trim();

          if (text == "Skladem") {
            $(this).addClass("skladem");
          }
          $(this).appendTo(produkt.find(".avbl"));
        });

        var cnt = produkt.find(".cnt");

        $(this)
          .find(".prices")
          .appendTo(cnt.find(".cena"));
        $(this)
          .find(".price-standard")
          .appendTo(cnt.find(".old"));

        let flagy = $(this).find(".flags");
        let flag_action = flagy.find(".flag-action");

        let price_save = $(this).find(".price-save");
        if (price_save.length) {
          cnt.find(".price-final").addClass("action");
          if (flag_action.length) {
            flag_action.text("Akce " + price_save.text());
          } else {
            flagy.prepend(
              '<span class="flag flag-action">Akce ' +
                price_save.text() +
                "</span>",
            );
          }
        }
      });
  });
} //function  pr_produkty()

export function upravProdukty() {
  pr_produkty();

  document.addEventListener("ShoptetDOMContentLoaded", function() {
    pr_produkty();
  });
} //export function  upravProdukty()
